import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '', children: [
      {
        path: '', loadComponent: () => import('./emailvalidation.component').then(m => m.EmailvalidationComponent),
        data: {
          title: 'Email Validation API for Real-Time Protection | KudosHub',
          description:'Protect your apps, CRMs, and signup forms with KudosHub’s real-time email validation API. Block fake, disposable, and risky emails instantly. Start free today.',
          keywords: 'email validation api, email scrubbing api, email verification api, eliminate invalid, spam traps, abusive, catch-all, disposable, toxic and role-based emails, 99% accuracy',
          ogTitle: 'Email Validation API for Real-Time Protection | KudosHub',
          ogDesc: 'Protect your apps, CRMs, and signup forms with KudosHub’s real-time email validation API. Block fake, disposable, and risky emails instantly. Start free today.',
          ogImage: 'https://kudoshub.com/theme/images/og-images/salient-features.webp',
          ogUrl: 'https://kudoshub.com/email-validation-api',
          twitterTitle: 'Email Validation API for Real-Time Protection | KudosHub',
          twitterDesc: 'Protect your apps, CRMs, and signup forms with KudosHub’s real-time email validation API. Block fake, disposable, and risky emails instantly. Start free today.',
          twitterImage: 'https://kudoshub.com/theme/images/og-images/salient-features.webp',
          dateModified: '2025-09-09T19:00:00+05:30'
        }
      }
    ]
  }
];
